module.exports = __webpack_public_path__ + "static/media/_DSC6160.be8b9f7f.jpg";